var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 255C197.916 255 255 197.916 255 127.5C255 57.0837 197.916 0 127.5 0C57.0837 0 0 57.0837 0 127.5C0 197.916 57.0837 255 127.5 255Z",
    fill: "#E13828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.91 167.68C142.57 167.67 141.25 167.45 139.98 167.03C136.96 165.91 134 164.62 131.12 163.16C121.28 158.51 106.42 151.49 96.22 152.82C88.24 153.87 80.82 157.72 76.85 162.87C76.12 163.83 74.75 164.01 73.79 163.28C73.79 163.28 73.78 163.27 73.77 163.26C72.81 162.51 72.63 161.13 73.38 160.16C78.1 154.03 86.43 149.65 95.65 148.44C107.12 146.91 122.69 154.29 132.99 159.16C135.7 160.52 138.48 161.74 141.31 162.81C144.46 163.81 147 163.06 148.11 160.79C149.06 159.03 148.61 156.84 147.04 155.59C143.46 153.12 140.49 151.02 136.44 148.09C115.91 133.23 114.09 117.56 114.26 111.51C114.26 99.8605 122.5 88.0005 136.3 88.0005C143.31 87.9605 149.78 91.7705 153.13 97.9305C156.48 91.7705 162.95 87.9505 169.96 88.0005C183.75 88.0005 192 99.8605 192 111.33C192.09 114.8 191.44 132.41 169.79 149.86C168.85 150.62 167.47 150.47 166.71 149.53C166.71 149.53 166.71 149.53 166.7 149.52C165.94 148.57 166.09 147.18 167.04 146.41C187.49 129.92 187.65 113.4 187.6 111.57V111.34C187.6 102.05 181 92.4405 169.96 92.4405C161.62 92.4405 156.89 98.4605 155.24 104.1C154.9 105.27 153.67 105.93 152.51 105.59C151.79 105.38 151.23 104.82 151.02 104.1C149.37 98.4605 144.64 92.4405 136.3 92.4405C125.26 92.4405 118.66 102.05 118.66 111.34V111.57C118.54 115.81 119.66 130.49 139.01 144.51C143.03 147.42 145.98 149.51 149.52 151.95C152.89 154.45 153.96 159.01 152.06 162.75C150.54 165.84 147.36 167.78 143.92 167.7L143.91 167.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21 165.45C62.99 165.45 62 164.45 62 163.23C62 162.76 62.15 162.3 62.43 161.93C82.05 135.2 105.89 140.43 118.35 145.93C119.47 146.42 119.98 147.73 119.48 148.85C118.99 149.97 117.68 150.48 116.56 149.98C102.83 143.92 82.9 141.53 66 164.55C65.58 165.12 64.92 165.46 64.22 165.45H64.21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaude);
export default __webpack_public_path__ + "static/media/saude.927d37c1d191be488ef9dae3446411ef.svg";
export { ForwardRef as ReactComponent };